document.addEventListener('teeinblue-event-component-injected', function () {
  globalThis.__tee_buy_now = false;
  const buyNowButton = document.getElementById('teeBuynowButton');
  if (buyNowButton && buyNowButton.dataset.popupBound !== 'true') {
    buyNowButton.dataset.popupBound = 'true';
    buyNowButton.addEventListener('click', function () {
      globalThis.__tee_buy_now = true;
    });
  }
});

function getMoneyText(cents) {
  if (typeof cents !== 'number') return '';
  if (globalThis.Shopify && typeof globalThis.Shopify.formatMoney === 'function') {
    return globalThis.Shopify.formatMoney(cents);
  }
  return `$${(cents / 100).toFixed(2)}`;
}

function normalizeUrl(url) {
  if (!url) return '';
  let value = String(url).trim();
  if (!value) return '';
  if ((value.startsWith('"') && value.endsWith('"')) || (value.startsWith("'") && value.endsWith("'"))) {
    value = value.slice(1, -1);
  }
  value = value
    .replace(/\\\//g, '/')
    .replace(/^https:\\\//i, 'https://')
    .replace(/^http:\\\//i, 'http://');
  if (value.startsWith('\\/')) value = value.slice(1);
  if (/%[0-9A-Fa-f]{2}/.test(value)) {
    try {
      value = decodeURIComponent(value);
    } catch (error) {
      // keep original value when decode fails
    }
  }
  if (value.startsWith('data:image/')) return value;
  if (value.startsWith('blob:')) return value;
  if (value.startsWith('//')) return `${window.location.protocol}${value}`;
  return value;
}

function isLikelyImageUrl(value) {
  if (!value) return false;
  const text = String(value).trim();
  if (!text) return false;
  if (/^data:image\//i.test(text)) return true;
  if (/^blob:/i.test(text)) return true;
  if (!/^https?:|^\/\/|^\//i.test(text)) return false;
  if (/\.(avif|gif|jpe?g|png|svg|webp)(\?|$)/i.test(text)) return true;
  return /(cdn|cloudfront|shopify|teeinblue|image|preview|mockup|thumbnail|render)/i.test(text);
}

function extractImageFromString(input, depth = 0) {
  if (!input || depth > 2) return '';
  const text = String(input).trim();
  if (!text) return '';

  const normalized = normalizeUrl(text);
  if (isLikelyImageUrl(normalized)) return normalized;

  if ((text.startsWith('{') && text.endsWith('}')) || (text.startsWith('[') && text.endsWith(']'))) {
    try {
      const parsed = JSON.parse(text);
      const parsedFound = findImageUrlInObject(parsed, 0);
      if (parsedFound) return parsedFound;
    } catch (error) {
      // no-op
    }
  }

  if (/%[0-9A-Fa-f]{2}/.test(text)) {
    try {
      const decoded = decodeURIComponent(text);
      const decodedFound = extractImageFromString(decoded, depth + 1);
      if (decodedFound) return decodedFound;
    } catch (error) {
      // no-op
    }
  }

  const dataImageMatch = text.match(/data:image\/[a-zA-Z0-9+.-]+;base64,[a-zA-Z0-9+/=]+/);
  if (dataImageMatch?.[0]) return dataImageMatch[0];

  const urlMatch = text.match(/https?:\/\/[^\s"'<>]+/i);
  if (urlMatch?.[0]) {
    const url = normalizeUrl(urlMatch[0]);
    if (isLikelyImageUrl(url)) return url;
  }

  return '';
}

function uniqueUrls(values) {
  const seen = new Set();
  return values
    .map((value) => normalizeUrl(value))
    .filter((value) => {
      if (!value || seen.has(value)) return false;
      seen.add(value);
      return true;
    });
}

function findImageUrlInObject(source, depth = 0) {
  if (!source || depth > 4) return '';

  if (typeof source === 'string') {
    const extracted = extractImageFromString(source);
    if (extracted) return extracted;
    return '';
  }

  if (Array.isArray(source)) {
    for (const item of source) {
      const found = findImageUrlInObject(item, depth + 1);
      if (found) return found;
    }
    return '';
  }

  if (typeof source !== 'object') return '';

  const prioritizedKeys = [
    '_customization_image',
    '_customization_preview',
    '_customization',
    '_preview',
    '_preview_image',
    '_preview_url',
    '_tb_preview',
    '_tb_image',
    'customization_image',
    'customizationImage',
    'customizationPreview',
    'customization_preview',
    'preview',
    'preview_image',
    'previewImage',
    'preview_url',
    'previewUrl',
    'mockup_image',
    'mockupImage',
    'thumbnail',
    'image',
    'src',
    'url',
  ];

  for (const key of prioritizedKeys) {
    if (!(key in source)) continue;
    const found = findImageUrlInObject(source[key], depth + 1);
    if (found) return found;
  }

  const entries = Object.entries(source);

  for (const [key, value] of entries) {
    if (!/(image|preview|thumbnail|mockup|render)/i.test(key)) continue;
    const found = findImageUrlInObject(value, depth + 1);
    if (found) return found;
  }

  for (const [, value] of entries) {
    const found = findImageUrlInObject(value, depth + 1);
    if (found) return found;
  }

  return '';
}

function getCurrentVariantId() {
  const variantInput =
    document.querySelector('form[action*="/cart/add"] [name="id"]') ||
    document.querySelector('.product_form [name="id"]') ||
    document.querySelector('input[name="id"]');
  const value = Number(variantInput?.value || 0);
  return Number.isFinite(value) && value > 0 ? value : 0;
}

function selectAddedItem(items, eventDetail) {
  if (!Array.isArray(items) || items.length === 0) return null;

  const detail = eventDetail || {};
  const detailKeyCandidates = [
    detail?.key,
    detail?.line_item_key,
    detail?.lineItemKey,
    detail?.item?.key,
    detail?.item?.line_item_key,
    detail?.item?.lineItemKey,
  ].filter(Boolean);

  for (const key of detailKeyCandidates) {
    const matchedByKey = items.find((item) => item?.key === key);
    if (matchedByKey) return matchedByKey;
  }

  const detailVariantIdCandidates = [
    Number(detail?.variant_id || 0),
    Number(detail?.variantId || 0),
    Number(detail?.item?.variant_id || 0),
    Number(detail?.item?.variantId || 0),
    getCurrentVariantId(),
  ].filter((id) => Number.isFinite(id) && id > 0);

  if (detailVariantIdCandidates.length > 0) {
    const matchedByVariant = items.filter((item) => detailVariantIdCandidates.includes(Number(item?.variant_id || 0)));
    if (matchedByVariant.length > 0) {
      const customized = matchedByVariant.filter((item) => item?.properties?._customization_id);
      const candidateList = customized.length > 0 ? customized : matchedByVariant;
      return candidateList[candidateList.length - 1];
    }
  }

  const detailProductIdCandidates = [
    Number(detail?.product_id || 0),
    Number(detail?.productId || 0),
    Number(detail?.item?.product_id || 0),
    Number(detail?.item?.productId || 0),
  ].filter((id) => Number.isFinite(id) && id > 0);

  if (detailProductIdCandidates.length > 0) {
    const matchedByDetailProduct = items.filter((item) =>
      detailProductIdCandidates.includes(Number(item?.product_id || 0))
    );
    if (matchedByDetailProduct.length > 0) {
      const customized = matchedByDetailProduct.filter((item) => item?.properties?._customization_id);
      const candidateList = customized.length > 0 ? customized : matchedByDetailProduct;
      return candidateList[candidateList.length - 1];
    }
  }

  const currentProductId = Number(globalThis?.TeeInBlueCampaign?.productId || 0);
  if (Number.isFinite(currentProductId) && currentProductId > 0) {
    const matchedByProduct = items.filter((item) => Number(item?.product_id || 0) === currentProductId);
    if (matchedByProduct.length > 0) {
      const customized = matchedByProduct.filter((item) => item?.properties?._customization_id);
      const candidateList = customized.length > 0 ? customized : matchedByProduct;
      return candidateList[candidateList.length - 1];
    }
  }

  const customizedItems = items.filter((item) => item?.properties?._customization_id);
  if (customizedItems.length > 0) return customizedItems[customizedItems.length - 1];

  return items[items.length - 1];
}

function getImageCandidates(addedItem, eventDetail) {
  const detailImage = findImageUrlInObject(eventDetail || {});
  const propertyImage = findImageUrlInObject(addedItem?.properties || {});
  const featuredImage = normalizeUrl(addedItem?.featured_image?.url || addedItem?.featured_image?.src || '');
  const lineImage = normalizeUrl(addedItem?.image || addedItem?.featured_image || '');
  const productImage = normalizeUrl(
    document.querySelector('.product-gallery img[src], .product__images img[src], .product-main-image img[src]')?.src || ''
  );

  return uniqueUrls([detailImage, propertyImage, featuredImage, lineImage, productImage]).filter(isLikelyImageUrl);
}

function renderFirstAvailableImage(candidates, container) {
  if (!container) return;
  if (!Array.isArray(candidates) || candidates.length === 0) {
    container.innerHTML = '';
    return;
  }

  const tryLoad = (index) => {
    if (index >= candidates.length) {
      container.innerHTML = '';
      return;
    }

    const imageUrl = candidates[index];
    const img = new Image();
    img.alt = 'Customization preview';
    img.width = 170;
    img.height = 170;
    img.decoding = 'async';

    img.onload = () => {
      container.innerHTML = '';
      container.appendChild(img);
    };

    img.onerror = () => {
      tryLoad(index + 1);
    };

    img.src = imageUrl;
  };

  tryLoad(0);
}

function delay(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

async function fetchCartWithRetry(eventDetail) {
  const retries = [0, 240, 520, 900];
  let latestCart = null;
  let latestItem = null;

  for (let index = 0; index < retries.length; index += 1) {
    const wait = retries[index];
    if (wait > 0) await delay(wait);

    const response = await fetch('/cart.js');
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    latestCart = await response.json();
    const items = Array.isArray(latestCart?.items) ? latestCart.items : [];
    latestItem = selectAddedItem(items, eventDetail);
    const imageCandidates = getImageCandidates(latestItem, eventDetail);

    if (latestItem && imageCandidates.length > 0) {
      return { cart: latestCart, addedItem: latestItem, imageCandidates };
    }
  }

  return {
    cart: latestCart,
    addedItem: latestItem,
    imageCandidates: getImageCandidates(latestItem, eventDetail),
  };
}

document.addEventListener('teeinblue-event-after-cart-added', async function (event) {
  if (globalThis.__tee_buy_now) {
    globalThis.__tee_buy_now = false;
    return;
  }

  const modal = document.getElementById('tee_add_to_cart_confirm');
  if (!modal) return;

  const wrapper = modal.querySelector('.confirm-modal_wrapper');
  const confirmButton = modal.querySelector('[data-confirm-modal]');
  const closeButtons = modal.querySelectorAll('[data-close-modal]');
  const imageContainer = modal.querySelector('.confirm-modal--image');
  const optionsContainer = modal.querySelector('.confirm-modal--options');
  const titleContainer = modal.querySelector('.confirm-modal--content-title');
  const priceContainer = modal.querySelector('.confirm-modal--price');

  const closeModal = () => {
    modal.style.display = 'none';
  };

  modal.style.display = 'block';

  if (wrapper) {
    wrapper.onclick = (event) => {
      if (event.target === wrapper) closeModal();
    };
  }

  closeButtons.forEach((button) => {
    button.onclick = closeModal;
  });

  if (confirmButton) {
    confirmButton.onclick = () => {
      globalThis.location.href = '/cart';
    };
  }

  if (imageContainer) {
    const earlyCandidates = getImageCandidates(null, event?.detail || {});
    if (earlyCandidates.length > 0) {
      renderFirstAvailableImage(earlyCandidates, imageContainer);
    } else {
      imageContainer.innerHTML =
        '<span class="tee-spinner tee-spinner--sm"><svg xmlns="http://www.w3.org/2000/svg" version="1.0" viewBox="0 0 128 128" class="tee-icon-loading tee-icon-loading--sm"><g><path d="M64 127.75A63.76 63.76 0 0152.8 1.23v14.23a49.8 49.8 0 1022.4 0V1.23A63.76 63.76 0 0164 127.75z"></path><animateTransform attributeName="transform" type="rotate" from="0 64 64" to="360 64 64" dur="1260ms" repeatCount="indefinite"></animateTransform></g></svg></span>';
    }
  }

  try {
    const result = await fetchCartWithRetry(event?.detail || {});
    const data = result?.cart;
    const addedItem = result?.addedItem;

    if (data && typeof globalThis.refreshCart === 'function') {
      globalThis.refreshCart(data);
    }

    if (!addedItem) {
      if (imageContainer) imageContainer.innerHTML = '';
      return;
    }

    const optionsWithValues = Array.isArray(addedItem?.options_with_values) ? addedItem.options_with_values : [];

    if (titleContainer && addedItem.product_title) {
      titleContainer.textContent = addedItem.product_title;
    }

    if (priceContainer && typeof addedItem.final_price === 'number') {
      priceContainer.innerHTML = getMoneyText(addedItem.final_price);
    }

    if (imageContainer) {
      renderFirstAvailableImage(result.imageCandidates, imageContainer);
    }

    if (optionsContainer) {
      optionsContainer.innerHTML = '';
      optionsWithValues
        .filter((option) => option?.value && option.value !== 'n/a')
        .forEach((option) => {
          const row = document.createElement('div');
          row.textContent = `${option.name}: ${option.value}`;
          optionsContainer.appendChild(row);
        });
    }
  } catch (error) {
    console.error('Error fetching cart data:', error);
    if (imageContainer) {
      imageContainer.innerHTML = '';
    }
  }
});
